import React from 'react';
import { useTranslation } from 'react-i18next';

const RequisitionsReportsListItem = ({ item, warehouses ,index}) => {
  const [t] = useTranslation('global');
  const formattedDate = item?.req_date ? item.req_date.substring(0, 10) : '-';

  // إيجاد اسم المخزن بناءً على معرف المخزن
  const warehouse = warehouses.find(w => w._id === item.warehouse_id);
  const warehouseName = warehouse ? warehouse.label : '-';

  // ترجمة نوع الإذن
  let reqTypeTranslated = '-';
  if(item.req_type?.trim() === 'PASH'){
    reqTypeTranslated = t("reports.Permission_Receipt");
  } else if(item.req_type?.trim() === 'PULL'){
    reqTypeTranslated = t("reports.Permission_Disbursement");
  } else if(item.req_type?.trim() === 'TRANS'){
    reqTypeTranslated = t("reports.Permission_Transfer");
  }

  // عدد المنتجات (في حال كانت البيانات لا تحتوي على هذا الحقل يتم عرض '-' أو يمكن تعديله لاحقاً)
  const numberOfProducts = item.product_count ? item.product_count : '-';

  return (
    <div className="grid grid-cols-12 gap-3 border-t px-4 py-2 cursor-pointer items-center hover:bg-[#251658]/5 hover:font-bold">
      <div className="text-center col-span-1 text-[#251658] text-xs">
      {index + 1}
      </div>
      <div className="text-center col-span-2 text-[#251658] text-xs">
        {item.req_no || '-'}
      </div>
      <div className="text-center col-span-2 text-[#251658] text-xs">
        {reqTypeTranslated}
      </div>
      <div className="text-center col-span-3 text-[#251658] text-xs">
        {warehouseName}
      </div>
      <div className="text-center col-span-2 text-[#251658] text-xs">
        {numberOfProducts}
      </div>
      <div className="text-center col-span-2 text-[#251658] text-xs">
        {formattedDate}
      </div>
    </div>
  );
};

export default RequisitionsReportsListItem;
